import { render, staticRenderFns } from "./ObsLinkDialog.vue?vue&type=template&id=3c12434e&scoped=true"
import script from "./ObsLinkDialog.vue?vue&type=script&lang=js"
export * from "./ObsLinkDialog.vue?vue&type=script&lang=js"
import style0 from "./ObsLinkDialog.vue?vue&type=style&index=0&id=3c12434e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12434e",
  null
  
)

export default component.exports